<div class="totalizers-container">
  <div class="totalizers-wrapper">
    <div class="totals-row">
      <div class="totals-card is-static">
        <div class="totals-card-title">SELECIONADO</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ getSelectedCount() }}</div>
          <div class="totals-card-amount">{{ formatAmount(getSelectedAmount()) }}</div>
        </div>
      </div>

      <div class="totals-card criadas" [class.active]="isActive('TODOS')" (click)="filterByStatus('TODOS')">
        <div class="totals-card-title">CRIADAS</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.totalCreated }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.totalCreated) }}</div>
        </div>
      </div>

      <div class="totals-card minhas-os" [class.active]="isActive('MY_ORDERS')" (click)="filterByStatus('MY_ORDERS')">
        <div class="totals-card-title">MINHAS OS</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.myServiceOrders }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.myServiceOrders) }}</div>
        </div>
      </div>

      <div class="totals-card concluidas" [class.active]="isActive('CONCLUIDA')" (click)="filterByStatus('CONCLUIDA')">
        <div class="totals-card-title">CONCLUÍDAS</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.concluded }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.concluded) }}</div>
        </div>
      </div>

      <div class="totals-card aprovadas" [class.active]="isActive('APROVADA')" (click)="filterByStatus('APROVADA')">
        <div class="totals-card-title">APROVADAS</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.approved }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.approved) }}</div>
        </div>
      </div>

      <div class="totals-card pendente" [class.active]="isActive('PENDENTE')" (click)="filterByStatus('PENDENTE')">
        <div class="totals-card-title">PENDENTE</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.pending }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.pending) }}</div>
        </div>
      </div>

      <div class="totals-card em-teste" [class.active]="isActive('EM TESTE')" (click)="filterByStatus('EM TESTE')">
        <div class="totals-card-title">EM TESTE</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.inProgress }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.inProgress) }}</div>
        </div>
      </div>

      <div class="totals-card em-analise" [class.active]="isActive('EM ANALISE')" (click)="filterByStatus('EM ANALISE')">
        <div class="totals-card-title">EM ANALISE</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.inAnalising }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.inAnalising) }}</div>
        </div>
      </div>

      <div class="totals-card cancelados" [class.active]="isActive('CANCELADA')" (click)="filterByStatus('CANCELADA')">
        <div class="totals-card-title">CANCELADOS</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.canceled }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.canceled) }}</div>
        </div>
      </div>

      <div class="totals-card rejeitados" [class.active]="isActive('REPROVADA')" (click)="filterByStatus('REPROVADA')">
        <div class="totals-card-title">REPROVADAS</div>
        <div class="totals-card-body">
          <div class="totals-card-value">{{ totalizers.rejected }}</div>
          <div class="totals-card-amount">{{ formatAmount(amounts.rejected) }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
